module.exports = __webpack_public_path__ + "img/banner4-5.61e142bf.png";